import './utils/tooltips'
import './utils/toggles'
import './utils/tabs'
import './utils/dropdowns'
import './utils/smooth-scroll'
import './utils/load-more'
import './utils/modal'
import './utils/popup'
import './utils/shop-message'
import './utils/video'
import './utils/preview'
import './utils/steps'
import './utils/search'
import './utils/sliders'
import './menu/menu-btns'
import './utils/gravity-form-inputs'
import '../../includes/acf/lightning-builder/page-components/pc-hero/js/hero-video'
import '../../includes/acf/lightning-builder/page-components/pc-sticky-menu/js/sticky-menu'
import '../../includes/acf/lightning-builder/page-components/pc-post-listing/js/filters'
import '../../includes/acf/lightning-builder/page-components/pc-gallery/js/gallery'
import './woocommerce/woocommerce'
// css
import '../css/app.css'

if (module.hot) {
    module.hot.accept()
}
